import { AdresseerbaarObject } from '../../../types/benkagg/adresseerbaarObjecten'

const buildAddressString = (
  result: Partial<
    Pick<
      AdresseerbaarObject,
      'huisnummer' | 'huisletter' | 'huisnummertoevoeging' | 'openbareruimteNaam'
    >
  >,
  extra: string | null = null,
) => {
  let str = `${result.openbareruimteNaam ?? ''} ${result.huisnummer ?? ''}`

  if (result.huisletter) {
    str = `${str}${result.huisletter}`
  }

  if (result.huisnummertoevoeging) {
    str = `${str}-${result.huisnummertoevoeging}`
  }

  if (extra) {
    str = `${str} ${extra}`
  }

  return str
}

export default buildAddressString
